// extracted by mini-css-extract-plugin
module.exports = {"switchIconWrapper":"MobileTransferEvent_switchIconWrapper__SSRX1","switchIcon":"MobileTransferEvent_switchIcon__W1ac2","bold":"MobileTransferEvent_bold__3gKys"};